import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import UpdatingBlock from 'components/common/UpdatingBlock'
import PromoBlock from '../PromoBlock'
import QuoteSummary from '../QuoteSummary'
import ApplyCouponForm from '../ApplyCouponForm'
import EstimatedTotalDisclaimer from '../EstimatedTotalDisclaimer'
import { SHOPPING_QUOTE_TOTAL_QUANTITY } from 'components/common/UpdatingBlock/constants'

const PromotionsAndSummary = ({
  className,
  formattedStorePhoneNumber,
  productAndServiceMinusInstantSavings,
  promotions: {
    rebate = [],
    coupons = []
  },
  quoteSummary: {
    displaymessage,
    estimatedTaxes,
    estimatedTotal,
    installationCost,
    instantSavings,
    mailInRebateTotal,
    productAndService,
    shopFees
  } = {},
  services = [],
  noEdit,
  paymentOptionsBannerContent
}) =>
  <Wrapper
    className={ className }
    data-at-promotions-and-summary
    noEdit={ noEdit }
    paymentBannerRendered={ paymentOptionsBannerContent }>
    <Block left noEdit={ noEdit }>
      {
        !noEdit &&
          <ApplyCouponForm />
      }
      {
        Boolean(coupons.length) &&
          <PromoBlock atId="applied-promotions" noEdit={ noEdit } name="Applied Promotions" promotions={ coupons } />
      }
      {
        Boolean(rebate.length) &&
          <PromoBlock atId="discounts" noEdit={ noEdit } name="Discounts After Purchase" promotions={ rebate } />
      }
    </Block>
    <Block right>
      <UpdatingBlock name={ SHOPPING_QUOTE_TOTAL_QUANTITY } message="Updating Cart">
        <Headline data-at-qoutesummary-title>Initial Quote Summary</Headline>
        {
          Boolean(productAndService) &&
          <QuoteSummary title="Products & Services" price={ productAndServiceMinusInstantSavings } />
        }
        {
          Boolean(shopFees) &&
          <QuoteSummary title="Shop Fees" price={ shopFees } />
        }
        {
          Boolean(installationCost) &&
          <QuoteSummary title="Installation Cost" price={ installationCost } />
        }
        {
          Boolean(estimatedTaxes) &&
          <QuoteSummary title="Estimated Taxes" price={ estimatedTaxes } />
        }
        {
          Boolean(instantSavings) &&
          <QuoteSummary title="Instant Savings" price={ instantSavings } savingField />
        }
        <Total>
          <QuoteSummary
            title="Estimated Total*"
            price={ estimatedTotal }
            displaymessage={ displaymessage }
            phoneNumber={ formattedStorePhoneNumber }
            total />
          {
            Boolean(estimatedTotal && services.length) &&
            <EstimatedTotalDisclaimer services={ services } />
          }
          {
            Boolean(mailInRebateTotal) &&
            <MailRebateTotal
              title="Estimated Total After Mail-In Rebate*"
              price={ mailInRebateTotal }
              compress
              savingField
              bolder />
          }
        </Total>
      </UpdatingBlock>
    </Block>
  </Wrapper>

PromotionsAndSummary.propTypes = {
  className: PropTypes.string,
  formattedStorePhoneNumber: PropTypes.string,
  noEdit: PropTypes.bool,
  paymentOptionsBannerContent: PropTypes.string,
  productAndServiceMinusInstantSavings: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  promotions: PropTypes.shape({
    rebate: PropTypes.arrayOf(PropTypes.shape({})),
    coupons: PropTypes.arrayOf()
  }),
  quoteSummary: PropTypes.shape(),
  services: PropTypes.arrayOf(PropTypes.shape())
}

export default PromotionsAndSummary

const Block = styled.div`
  ${Media.desktop`
    width: 312px;
  `}
  ${Media.mobile`
    margin-bottom: 40px;
  `}
  ${props => props.right && css`
    ${Media.desktop`
      float: right;
    `}
  `}
  ${props => props.left && css`
    ${Media.desktop`
      float: left;
      width: 332px;
    `}
  `}

  ${props => props.noEdit && css`
    ${Media.desktop`
      padding-right: 30px;
    `}
  `}
`

const Wrapper = styled.div`
  border-top: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('padding', '20px 0 50px', '20px 0 10px')}
  ${props => props.paymentBannerRendered && css`
    ${Media.desktop`
      display: flex;
    `}
  `}
  ${props => props.noEdit && css`
    ${Media.desktop`
      padding-top: 20px;
    `}
  `}
  ${Mixin.clearFix()}
`

const Headline = styled.div`
  margin-bottom: 6px;
  font-weight: 700;
  line-height: 19px;
  color: ${Theme.colors.sub_grey};
`

const Total = styled.div`
  padding: 12px 0 0;
  margin-top: 10px;
  border-top: 1px solid ${Theme.colors.light_grey};
`

const MailRebateTotal = styled(QuoteSummary)`
  margin-top: 10px;
`
